import { http, geocoding } from "@/http";

class CoverageService {
  async coverage(params) {
    return await http.get(
      `/address-coverage/coverage?lat=${params.latitude}&long=${params.longitude}`
    );
  }

  async reverseGeocoding(lat, lng) {
    if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng)) ||
        lat === "" || lng === "" || lat == null || lng == null) {
      return Promise.resolve({ data: { results: [] } });
    }
    return await geocoding.get(`/v4/geocode/location/${lat},${lng}`);
  }
  async getGeocoding(value) {
    const address = (value || "").trim();
    if (!address) {
      return Promise.resolve({ data: { results: [] } });
    }
    return await geocoding.get(
      `/v4/geocode/address/${encodeURIComponent(address)}`
    );
  }
}
export default new CoverageService();
